import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { getTestIds } from 'seagull/utils/TestIds';
import { GenerateServiceDescriptionResponseType } from '~/hooks/reactQuery/mutations/useGenerateServiceDescription.types';
import { isPromptQuestion } from './SuggestedDescriptionDisplay/SuggestedDescriptionDisplay.utils';
const canUndo = (response)=>{
    var _response_canUndo;
    return (response === null || response === void 0 ? void 0 : response.type) === GenerateServiceDescriptionResponseType.Message ? (_response_canUndo = response.canUndo) !== null && _response_canUndo !== void 0 ? _response_canUndo : false : false;
};
const isClarification = (response)=>{
    return (response === null || response === void 0 ? void 0 : response.type) === GenerateServiceDescriptionResponseType.Clarification;
};
const conversationId = (response)=>{
    var _ref;
    return (_ref = response === null || response === void 0 ? void 0 : response.conversationId) !== null && _ref !== void 0 ? _ref : '';
};
const description = (response)=>{
    if (!response) return null;
    switch(response.type){
        case GenerateServiceDescriptionResponseType.Clarification:
            return response.message;
        case GenerateServiceDescriptionResponseType.Start:
        case GenerateServiceDescriptionResponseType.Message:
            return response.description;
    }
};
const isEmptyResponseData = (response)=>response.isClarification && !response.conversationId || response.conversationId === '' || isPromptQuestion(response.description);
export const emptyResponseData = {
    isEmpty: true,
    canUndo: false,
    isClarification: false,
    conversationId: '',
    description: null
};
export const getResponseData = (response)=>{
    const data = {
        canUndo: canUndo(response),
        isClarification: isClarification(response),
        conversationId: conversationId(response),
        description: description(response)
    };
    return _object_spread_props(_object_spread({}, data), {
        isEmpty: isEmptyResponseData(data)
    });
};
export const GetHelpMeWriteDrawerTID = (parentTestId)=>getTestIds(parentTestId);
